import { useNavigate } from "react-router-dom";
import GeneralDashboardItem from "./GeneralDashboardItem";
import SectionedScrollable from "./SectionedScrollable";
import Routes from "router/routes";

const ToolsAndTemplates = () => {
  const navigate = useNavigate();
  const TOOLS_AND_TEMPLATES = [
    {
      title: "Templates",
      description: "Articles on how to use Giv",
      image: "/assets/images/scissors.png",
      onclick: () => {
        navigate(Routes.TEMPLATES);
      },
      buttonText: "View Templates",
    },
   {
      title: "Fundraising 101",
      description: "Learn to fund raise like a pro.",
      image: "/assets/images/writer-book.png",
      onclick: () => {
        navigate(Routes.FUNDRAISER_BLOG);
      },
      buttonText: "Start Now",
    },
  ];
  return (
    <div className="mt-10">
      <SectionedScrollable
        title="Guides and Templates"
        description="Yes, sign me up to hear updates from Giv about how to change people’s lives. Unsubscribe anytime."
      >
        <div className="scrollbar-hide mt-5 flex flex-row gap-x-4 overflow-x-auto">
          {TOOLS_AND_TEMPLATES.map((item) => (
            <GeneralDashboardItem key={item.title} {...item} />
          ))}
        </div>
      </SectionedScrollable>
    </div>
  );
};

export default ToolsAndTemplates;
